var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCommunity = function SvgCommunity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 240,
    viewBox: "0 0 353 240",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.879 4.02788L175.234 9.52476L170.879 35.7359L175.234 46.2187C175.234 46.2187 171.905 54.9131 174.466 57.47C177.027 60.0268 179.716 64.7572 179.716 64.7572C179.716 64.7572 179.716 84.703 181.254 86.2358L184.454 89.4334C184.454 89.4334 175.993 102.09 175.993 107.844C175.993 113.599 183.037 140.191 183.037 140.191C183.037 140.191 182.781 170.875 184.446 175.094H188.545C188.545 175.094 192.26 156.552 189.441 139.039L192.123 113.597L194.687 114.627L203.528 139.808C203.528 139.808 206.475 170.236 210.443 175.989H214.798C214.798 175.989 216.335 149.524 211.341 136.993C211.341 136.993 208.658 110.529 206.731 103.369L199.943 90.9663C199.943 90.9663 209.164 85.9804 211.213 82.0184C213.262 78.0564 218.001 83.8067 222.867 82.1461C227.734 80.4855 227.734 76.5195 227.734 76.5195L245.919 62.4559L256.032 62.0727L252.061 60.2823C252.061 60.2823 256.736 62.392 256.736 61.2424C256.736 60.0927 253.279 59.9629 253.279 59.9629C253.279 59.9629 256.864 58.5557 255.712 58.5557C254.56 58.5557 249.436 58.8133 249.436 58.8133L250.206 57.0229L245.851 58.6835L244.954 60.6016L227.538 69.5515L208.198 57.917C208.198 57.917 213.397 46.4989 203.451 34.3926C201.041 31.4546 196.664 34.5203 196.664 34.5203C196.664 34.5203 191.797 33.3686 190.902 35.159C190.006 36.9494 190.39 53.0589 190.39 53.0589C190.39 53.0589 184.37 54.7215 183.602 47.4342C182.834 40.147 181.681 38.8675 178.992 38.8675L176.814 33.8816L179.004 9.46089V3.96401C179.004 3.96401 176.955 3.96401 176.955 6.13763C176.955 6.13763 174.522 0 172.208 0L173.744 2.17361C173.744 2.17361 170.935 0.127739 170.935 0.894169C170.935 1.6606 172.856 3.57256 172.856 3.57256C172.856 3.57256 169.399 2.04588 170.879 4.02788Z",
    fill: "#171744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.428 155.567C149.428 150.416 138.79 122.792 138.79 122.792L134.557 98.3526L131.926 85.2182L134.902 79.8512L143.71 82.9416C143.71 82.9416 148.97 80.428 148.97 72.0921C148.97 72.0921 154.462 75.9757 157.551 72.8915C160.641 69.8072 156.639 52.443 156.639 52.443L156.526 42.9656C156.526 42.9656 157.211 40.7941 156.982 40.5675C156.753 40.3408 155.874 42.5371 155.841 42.6278C155.861 42.5392 156.4 40.4315 155.841 39.0902C155.281 37.749 155.04 42.5165 155.04 42.5165C155.04 42.5165 154.697 39.8896 154.239 39.4261C153.781 38.9625 154.239 43.081 154.239 43.081V44.5665C154.239 44.5665 152.409 43.3097 151.837 43.3097C151.265 43.3097 154.239 46.0499 154.239 46.0499L154.355 51.075C154.355 51.075 153.552 50.3889 152.751 50.6176C151.95 50.8463 152.066 58.9556 152.066 58.9556C152.066 58.9556 143.605 50.6176 137.882 49.9336L137.537 48.7901C137.537 48.7901 140.513 45.1372 140.513 43.6517C140.513 43.6517 141.999 42.6216 141.999 41.1402C141.999 39.6589 140.397 41.1402 140.397 41.1402C140.397 41.1402 141.314 35.4291 139.254 33.3729C137.195 31.3167 136.394 30.1753 132.277 30.9747L131.532 30.4617C131.532 30.4617 124.554 26.236 122.494 28.2922C120.435 30.3484 123.64 34.1167 122.494 37.885C121.349 41.6532 120.55 46.1076 118.72 44.2719C116.889 42.4362 115.281 47.5931 118.714 47.5931C122.146 47.5931 124.079 46.7937 124.079 46.7937C125.003 45.8501 126.142 45.1432 127.398 44.7334L130.143 46.1035L129.914 47.5869C129.914 47.5869 126.818 48.5017 126.818 49.6472C126.818 50.7927 122.013 48.617 116.637 52.0454C116.637 52.0454 99.0769 53.4732 96.103 60.3257C93.1291 67.1783 99.9932 75.1722 106.513 76.6556L112.576 81.5674C112.576 81.5674 105.598 93.6716 109.257 104.406L111.775 117.425C111.775 117.425 111.336 142.319 115.57 155.223C119.805 168.127 121.632 163.794 121.632 163.794C121.632 163.794 117.399 126.915 118.771 123.138C120.144 119.361 123 107.601 123 107.601L129.864 121.992C129.864 121.992 137.413 143.347 146.564 157.623C155.715 171.899 160.973 165.273 160.973 165.273C160.973 165.273 149.428 160.703 149.428 155.567ZM114.08 77.795H113.049L110.188 74.7045C110.188 74.7045 109.959 68.194 107.899 67.0526H114.076C114.076 67.0526 113.62 71.7356 114.076 73.2191C114.532 74.7025 114.08 77.795 114.08 77.795Z",
    fill: "#171744"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.065 236.971C121.608 236.687 119.123 236.379 116.611 236.046C113.247 235.603 109.945 235.103 106.705 234.546C83.6421 230.601 63.667 223.899 46.3706 215.359L48.4075 203.965L50.7004 191.144L107.315 190.72C107.315 190.72 105.605 195.842 109.813 205.243C111.257 208.488 113.424 212.248 116.602 216.473C128.985 232.956 124.065 236.971 124.065 236.971Z",
    fill: "#233661"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.34,
    d: "M109.821 205.243C91.1127 217.932 54.9598 206.246 48.4053 203.965L50.6981 191.144L107.315 190.72C107.315 190.72 105.613 195.842 109.821 205.243Z",
    fill: "url(#paint0_linear)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.093 130.495L130.51 145.869L127.897 151.968C127.897 151.968 116.924 148.937 117.428 145.187C118.047 140.655 116.19 143.539 113.713 143.539C111.237 143.539 110.205 142.097 110.205 142.097L110.182 142.148C109.846 142.904 106.005 151.832 108.985 157.425C111.373 161.911 108.756 163.829 107.404 164.48C107.176 164.593 106.94 164.687 106.696 164.76C107.935 171.353 105.572 172.021 105.458 174.489C105.439 174.901 105.429 175.313 105.429 175.725C105.429 178.181 105.774 180.365 106.694 181.865C114.536 194.638 105.592 200.063 105.592 200.063C105.592 200.063 83.3036 206.104 66.7295 203.102C61.5144 202.157 56.8668 200.317 53.6556 197.111C49.6106 193.073 48.3847 179.885 47.877 166.824C47.6996 162.24 49.3217 158.878 48.4962 156.523C44.8743 146.277 42.5113 137.523 42.3874 137.092V137.076L42.3111 137.154L33.4369 146.013L20.6416 153.224L30.754 170.325H14.4462L6.67612 161.921C4.58536 159.662 3.33719 156.753 3.14139 153.684C2.94559 150.614 3.81407 147.571 5.6009 145.066C15.9589 130.524 36.644 103.406 47.0825 103.071C50.9784 102.981 54.8757 103.169 58.7448 103.633L67.4848 104.597C86.7727 106.738 97.8427 107.956 98.1833 107.993H98.1977L98.2411 108.011L129.61 121.696L137.093 130.495Z",
    fill: "#EC1659"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1996 107.995C98.1996 107.995 97.9933 108.347 97.595 108.922C95.5188 111.928 88.2172 121.038 77.8097 117.969C65.5097 114.34 53.5832 103.408 53.3975 103.237C55.1666 103.51 56.9546 103.642 58.7447 103.633C61.182 103.606 63.9041 103.252 65.5964 102.032C65.804 101.886 65.9987 101.722 66.1783 101.542C67.8747 99.8359 69.7837 96.7578 71.2304 92.7341C72.2279 89.9351 72.9036 87.0321 73.2447 84.0808C73.3932 82.7993 73.4861 81.4725 73.5088 80.1106C73.5088 79.8263 73.5088 79.5399 73.5088 79.2515L74.3983 79.8077L92.5202 85.3541C92.5202 85.3541 92.1797 86.7036 91.7132 88.5949C90.9228 91.7987 89.7671 96.5539 89.2821 98.8964C88.857 100.944 88.7662 102.772 89.5009 103.499C91.5853 105.549 98.1996 107.995 98.1996 107.995Z",
    fill: "#C98D73"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2048 66.1931C68.2048 66.1931 64.6964 64.3533 65.9037 58.9821C67.111 53.6109 68.9767 53.6129 68.9767 53.6129C68.9767 53.6129 66.9129 51.7587 68.956 48.4622C70.9991 45.1657 75.3268 42.0567 83.3755 42.8541C83.3755 42.8541 95.9645 41.3583 95.9397 36.8256C95.9397 36.8256 100.676 34.3347 102.762 39.8872C104.849 45.4397 105.07 48.5405 104.048 51.2189C103.027 53.8973 100.35 54.9418 100.35 54.9418C100.35 54.9418 74.4209 72.3472 68.2048 66.1931Z",
    fill: "url(#paint1_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.008 73.6186C100.008 73.6186 106.416 73.8617 106.395 68.711C106.374 63.5603 104.719 62.7361 104.719 62.7361C104.719 62.7361 106.467 61.603 106.449 57.0703C106.43 52.5377 100.85 50.7061 100.85 50.7061L99.9395 54.9338L100.008 73.6186Z",
    fill: "url(#paint2_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.5347 85.3539C92.5347 85.3539 90.0685 95.1733 89.2946 98.8942C83.6936 98.0515 77.0132 95.4288 71.2388 92.7257C72.6761 88.6722 73.4429 84.4121 73.5089 80.1125L74.4046 79.8076L92.5347 85.3539Z",
    fill: "url(#paint3_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1651 64.343C69.8356 61.6523 72.0211 66.0737 72.0211 66.0737C72.0211 66.0737 73.635 56.8023 77.5396 52.8651C81.4443 48.9279 94.446 49.0845 100.447 55.0346C100.447 55.0346 101.935 65.1301 100.515 71.311C99.0956 77.4918 98.0988 85.3313 91.9199 88.4485C91.9199 88.4485 85.4397 93.523 80.27 90.8652C75.1003 88.2075 70.7354 81.221 69.8893 76.0744L69.4559 71.1296C69.4559 71.1296 63.44 68.0928 67.1651 64.343Z",
    fill: "#C98D73"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5823 66.0243C83.5823 66.0243 82.9466 62.1098 78.4126 63.3686C78.4126 63.3686 76.5552 63.9867 76.5552 64.6048C76.5655 64.613 81.9148 62.9421 83.5823 66.0243Z",
    fill: "#242424"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0285 68.0248C98.0285 68.0248 97.3949 64.1103 92.8691 65.3691C92.8691 65.3691 91.0117 65.9872 91.0117 66.6053C91.0117 66.6115 96.3775 64.9406 98.0285 68.0248Z",
    fill: "#242424"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8925 68.6899L83.6152 74.6772L88.9852 75.6847L86.8925 68.6899Z",
    fill: "#F2A891"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0557 77.7925L93.3275 79.7889C93.3275 79.7889 88.1867 83.9301 83.6402 82.5064C80.0988 81.3959 78.0557 77.7925 78.0557 77.7925Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.181 198.759C257.831 208.854 254.907 222.115 253.275 229.161C238.151 233.776 220.989 237.173 201.439 238.844C196.771 238.168 193.39 241.37 192.978 238.729C191.475 229.484 198.29 205.809 201.255 197.935C202.081 195.732 202.628 194.404 202.628 194.404C202.628 194.404 211.296 191.89 221.87 189.393C237.968 185.594 258.49 181.838 259.65 187.048C260.145 189.315 259.866 193.629 259.181 198.759Z",
    fill: "#233661"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M117.888 95.9028L119.838 100.075C118.856 98.7831 117.908 97.5882 117.013 96.49L117.888 95.9028Z",
    fill: "#EEC05B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M120.222 100.584C122.263 103.289 124.447 106.396 126.636 109.855C123.768 109.913 121.45 109.948 119.912 109.948C109.528 109.956 120.748 99.9926 120.222 100.584Z",
    fill: "#EEC05B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M252.513 120.449C249.333 123.624 252.878 143.644 256.209 159.09C256.727 161.493 257.241 163.784 257.722 165.889C258.403 168.873 259.024 171.471 259.507 173.451C259.508 173.458 259.508 173.466 259.507 173.473C259.714 174.341 259.903 175.089 260.056 175.698C260.349 176.879 260.518 177.54 260.518 177.54C265.643 178.661 260.357 186.655 260.357 189.696C260.357 192.737 265.162 189.696 259.326 198.57C259.282 198.636 259.235 198.702 259.185 198.776C255.14 204.24 236.001 204.413 220.545 202.53C211.799 201.467 204.242 199.744 201.251 197.952L201.101 197.859C193.174 192.822 200.781 191.303 195.015 189.224C189.249 187.145 193.093 181.869 193.093 181.869C187.327 181.869 187.808 176.912 191.812 172.913C195.815 168.914 193.093 166.198 193.093 166.198C189.067 149.38 174.726 138.384 161.105 131.548C146.814 124.368 133.304 121.752 133.304 121.752C131.292 117.681 129.067 113.718 126.638 109.88C145.575 109.487 188.446 107.993 188.446 107.993C188.446 107.993 199.016 103.516 209.341 98.8926C219.666 94.2693 233.454 95.3592 238.1 94.2404C242.745 93.1217 246.588 88.3232 248.992 88.3232C251.397 88.3232 258.122 89.1226 258.122 89.1226L258.188 88.6508C258.331 88.954 258.495 89.246 258.682 89.5244C261.026 92.9795 268.588 99.6199 274.961 103.328C272.003 110.894 257.594 115.377 252.513 120.449Z",
    fill: "#EEC05B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M283.909 89.1079C281.185 95.6637 266.931 80.4731 266.931 80.4731C266.931 80.4731 267.36 78.9279 268.037 76.4556C273.9 79.5027 283.909 85.2633 283.909 89.1079Z",
    fill: "#EEC05B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M213.913 126.844C213.913 126.844 213.801 126.432 213.589 125.744C212.524 122.289 208.896 111.841 203.821 111.174C197.735 110.374 188.524 108.056 188.524 108.056C188.524 108.056 188.652 106.202 188.753 103.604C188.803 102.395 188.844 101.018 188.865 99.5885C188.931 94.9631 188.778 89.7732 187.884 87.7479C186.122 83.751 210.549 93.7434 210.549 93.7434C210.549 93.7434 208.392 97.6724 209.837 102.03C210.024 102.593 210.263 103.138 210.549 103.658C213.271 108.615 215.995 110.044 215.995 110.044C215.995 110.044 220.479 122.847 213.913 126.844Z",
    fill: "#FDCEBC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.837 102.032C203.041 104.072 194.796 101.896 188.865 99.5885C188.931 94.9631 188.778 89.7732 187.884 87.7479C186.122 83.751 210.549 93.7434 210.549 93.7434C210.549 93.7434 208.392 97.6744 209.837 102.032Z",
    fill: "url(#paint4_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M212.47 88.3085C202.38 91.9862 181.637 85.9886 181.637 85.9886C181.637 85.9886 181.14 85.6425 180.418 85.2181C178.895 84.3239 176.371 83.096 175.394 84.0705L172.272 78.553C172.272 78.553 167.146 67.2008 173.232 61.125C179.318 55.0492 187.573 55.4818 193.376 57.025L194.1 57.2084L196.296 57.7667C196.296 57.7667 196.296 59.0461 196.777 59.5262C197.258 60.0062 201.899 63.0452 201.899 63.0452C201.899 63.0452 205.744 64.9633 206.704 65.9296L206.739 65.9646C207.325 66.5827 210.879 70.8043 213.399 75.4729C216.203 80.6545 217.726 86.3925 212.47 88.3085Z",
    fill: "#FDCEBC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.561 74.0757C185.561 74.0757 185.883 69.1187 190.526 69.1187L191.327 69.2794C191.327 69.2794 186.843 70.0787 185.561 74.0757Z",
    fill: "#242424"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M179.96 68.7994C179.96 68.7994 181.241 64.9611 184.764 64.003C184.764 64.003 183.004 61.9242 180.43 64.003C177.017 66.7762 179.96 68.7994 179.96 68.7994Z",
    fill: "#EE5F44"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.643 87.297C182.643 87.297 179.71 89.5077 175.704 87.2682C171.698 85.0286 171.861 82.4718 172.815 81.5117C173.768 80.5516 176.34 81.1924 177.46 82.3111C178.581 83.4299 182.643 87.297 182.643 87.297Z",
    fill: "#FDCEBC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.643 87.2966C182.132 87.6421 181.566 87.8972 180.969 88.0507C179.824 86.9546 177.211 84.4534 176.346 83.5901C175.418 82.663 173.498 82.0655 172.32 82.4322C172.401 82.0857 172.574 81.7675 172.821 81.5113C173.783 80.5533 176.346 81.1919 177.467 82.3107C178.587 83.4294 182.643 87.2966 182.643 87.2966Z",
    fill: "#F2A891"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M285.511 40.8168C285.511 40.8168 286.076 61.9245 285.426 76.4744C285.16 82.3854 284.695 87.2147 283.909 89.1081C282.479 92.5468 277.879 90.0023 273.828 86.8068C271.394 84.8468 269.091 82.7313 266.933 80.4734C266.933 80.4734 267.362 78.9282 268.039 76.4558C268.691 74.0824 269.57 70.8498 270.515 67.3102C273.242 57.1096 276.544 44.342 276.544 42.0962C276.544 42.0962 271.9 35.219 272.059 31.702C272.059 31.702 271.419 23.0673 276.224 20.1891C280.987 17.3356 278.038 25.7952 277.988 25.9435C278.054 25.8364 280.659 21.689 283.354 18.4028C285.131 16.2292 286.945 14.4326 288.082 14.4326C290.971 14.4326 286.481 21.9486 286.481 21.9486C286.481 21.9486 289.044 21.6272 289.044 23.0673C289.044 24.5075 291.126 23.8667 291.126 24.9855C291.126 26.1042 292.247 27.5444 292.247 29.3121C292.247 31.0798 285.511 40.8168 285.511 40.8168Z",
    fill: "#FDCEBC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M283.909 89.1081C283.909 94.5452 275.258 102.381 275.258 102.381C275.178 102.697 275.078 103.008 274.959 103.312C268.588 99.6033 261.026 92.9629 258.682 89.5078C258.494 89.2306 258.329 88.9385 258.188 88.6342L258.76 84.6311C258.76 78.5532 263.887 74.3955 263.887 74.3955C263.887 74.3955 265.606 75.1928 268.037 76.4558C267.36 78.9282 266.931 80.4734 266.931 80.4734C266.931 80.4734 281.185 95.664 283.909 89.1081Z",
    fill: "url(#paint5_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.131 100.701L119.838 100.083C119.968 100.252 120.096 100.421 120.224 100.592C120.191 100.626 120.16 100.663 120.131 100.701Z",
    fill: "#EEC05B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M213.599 125.744C212.534 122.289 208.906 111.841 203.831 111.174C197.745 110.374 188.535 108.056 188.535 108.056C188.535 108.056 188.663 106.202 188.764 103.604C194.567 104.85 204.789 107.333 207.276 109.816C210.2 112.746 212.798 122.544 213.599 125.744Z",
    fill: "url(#paint6_linear)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M204.863 176.016C204.863 176.016 204.863 178.735 193.17 181.772C193.17 181.772 196.214 184.657 202.62 183.214C209.026 181.772 204.863 176.016 204.863 176.016Z",
    fill: "url(#paint7_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M209.34 98.8756C209.34 98.8756 216.798 95.8635 220.76 95.8037C220.76 95.8037 216.396 98.6222 217.516 102.78C218.637 106.938 219.279 113.493 219.279 113.493C219.279 113.493 208.05 103.927 209.34 98.8756Z",
    fill: "url(#paint8_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M285.511 40.8167C285.511 40.8167 286.076 61.9244 285.426 76.4743C285.16 82.3853 284.695 87.2146 283.909 89.108C282.479 92.5467 277.879 90.0022 273.828 86.8067C280.182 80.4197 282.495 44.1132 283.344 18.4048C285.121 16.2312 286.935 14.4346 288.072 14.4346C290.961 14.4346 286.47 21.9505 286.47 21.9505C286.47 21.9505 289.033 21.6291 289.033 23.0693C289.033 24.5094 291.116 23.8687 291.116 24.9874C291.116 26.1062 292.236 27.5463 292.236 29.314C292.236 31.0818 285.511 40.8167 285.511 40.8167Z",
    fill: "url(#paint9_linear)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M214.695 73.3962L213.399 75.4565L212.78 76.4475L205.97 70.9753L193.174 60.7171C192.761 59.9095 193.174 58.6733 194.101 57.2002L196.297 57.7585C196.297 57.7585 196.297 59.038 196.778 59.518C197.258 59.9981 201.9 63.0453 201.9 63.0453C201.9 63.0453 205.745 64.9634 206.704 65.9297L206.739 65.9647C207.893 66.2325 212.97 69.0551 214.152 72.7266C214.152 72.7287 214.342 72.9841 214.695 73.3962Z",
    fill: "url(#paint10_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M221.52 89.0276C218.958 93.3543 212.87 98.299 201.018 97.0237C192.701 96.1254 184.545 89.246 180.418 85.2182C178.661 83.506 177.638 82.3111 177.638 82.3111C177.638 82.3111 177.314 79.0022 180.199 78.1534C185.645 76.5546 191.252 82.7911 194.936 81.5117C198.62 80.2322 196.057 74.6365 201.01 72.0776C203.045 71.0309 204.7 70.8414 205.948 70.9836C207.748 71.1896 208.697 72.0776 208.697 72.0776C208.697 72.0776 208.004 68.606 207.104 66.8815C206.978 66.6183 206.813 66.3753 206.615 66.1604C206.409 65.9544 206.481 65.8987 206.731 65.9544C207.884 66.2222 212.961 69.0448 214.144 72.7163C214.144 72.7163 214.334 72.982 214.686 73.3941C215.46 74.2945 217.021 75.885 219.109 76.8719C222.161 78.3141 224.083 84.7113 221.52 89.0276Z",
    fill: "#EE5F44"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M200.298 79.0333L206.376 74.3955C206.376 74.3955 207.657 75.8377 207.017 77.5952C206.378 79.3526 203.821 80.3127 200.298 79.0333Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M198.375 65.9297C198.375 65.9297 201.264 62.7321 201.9 63.0453C201.9 63.0453 198.216 62.2438 198.375 65.9297Z",
    fill: "#242424"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M196.214 57.8471C196.214 57.8471 193.17 58.9659 192.85 60.2453C192.53 61.5248 191.088 59.7653 192.208 57.8471C193.329 55.929 196.214 57.8471 196.214 57.8471Z",
    fill: "#EE5F44"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M212.773 204.318C212.773 204.318 212.086 222.296 198.847 220.93L201.93 201.637C201.93 201.637 209.597 204.365 212.773 204.318Z",
    fill: "url(#paint11_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.34,
    d: "M220.542 202.513C218.932 216.716 216.926 229.818 215.714 237.266C211.104 237.895 206.346 238.42 201.439 238.84C196.773 238.162 193.403 241.366 192.978 238.725C191.476 229.48 198.29 205.805 201.256 197.931L201.105 197.838C193.178 192.8 200.785 191.282 195.019 189.203C189.253 187.124 193.098 181.848 193.098 181.848C187.332 181.848 187.812 176.891 191.816 172.892C195.82 168.893 193.098 166.177 193.098 166.177C189.071 149.359 174.73 138.363 161.109 131.527L188.421 108.102C188.421 108.102 197.405 106.406 207.201 113.252C209.265 114.695 211.857 121.842 213.805 126.85C226.394 159.197 221.029 198.201 220.542 202.513Z",
    fill: "url(#paint12_linear)"
  }), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M177.626 239.973C159.217 240.192 138.953 238.99 116.61 236.046C113.247 235.603 109.945 235.103 106.704 234.546C106.601 227.943 109.424 219.337 113.102 213.383C113.575 212.617 114.033 211.846 114.472 211.078C115.946 208.504 117.225 205.947 118.301 203.613C119.221 201.617 119.993 199.781 120.61 198.236C120.926 197.445 121.2 196.73 121.436 196.107C122.067 194.414 122.393 193.398 122.393 193.398L161.299 191.144L168.609 190.72C168.609 190.72 168.559 192.094 168.625 194.202C168.625 194.309 168.625 194.42 168.625 194.533C168.625 194.566 168.625 194.601 168.625 194.634C168.836 199.76 176.777 232.476 177.626 239.973Z",
    fill: "url(#paint13_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M168.648 194.634H168.609C164.069 194.634 150.861 193.192 142.193 201.845C136.016 208.012 121.18 212.614 114.464 211.077C117.647 205.442 120.297 199.524 122.381 193.398L161.287 191.144C164.905 192.491 167.685 193.616 168.626 194.202C169.071 194.473 169.109 194.628 168.648 194.634Z",
    fill: "url(#paint14_linear)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.795 122.223C135.795 122.223 138.959 112.976 141.807 113.895C144.655 114.814 150.268 87.5585 151.841 88.0653C171.789 94.5017 152.416 70.6207 147.327 66.3601C142.238 62.0994 116.67 80.4257 115.029 98.239C114.922 99.4093 124.3 120.437 135.795 122.223Z",
    fill: "url(#paint15_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M162.936 110.844C160.767 114.328 158.23 133.751 143.018 135.496C127.806 137.241 128.159 118.043 128.159 118.043C128.159 118.043 136.082 120.556 137.688 112.26C138.001 110.638 138.074 108.603 137.797 106.052C137.265 101.148 150.227 98.9708 150.628 103.786C150.834 106.285 151.278 108.092 151.866 109.377C154.598 115.35 163.344 110.185 162.936 110.844Z",
    fill: "#FDCEBC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M188.421 108.102C188.421 108.102 173.805 117.48 172.682 128.058C172.063 133.864 170.117 139.389 168.613 145.951C168.028 148.453 167.57 150.983 167.24 153.531C166.761 157.31 166.612 161.124 166.797 164.929C167.581 181.57 173.376 194.414 167.874 194.671C162.372 194.929 152.317 191.517 147.676 192.868C143.034 194.22 120.589 206.442 116.862 203.059C113.135 199.676 123.938 198.355 121.734 196.352C119.53 194.35 114.893 195.703 115.613 190.326C116.334 184.949 126.867 178.376 125.484 169.704C124.892 165.996 123.394 160.915 121.926 155.876C121.332 153.832 120.744 151.794 120.224 149.858C120.108 149.429 119.996 149.006 119.887 148.588C118.874 144.674 118.214 141.266 118.467 139.212C118.779 136.694 119.047 133.575 119.993 130.312C120.854 127.2 122.364 124.305 124.423 121.817C124.836 121.31 125.303 120.807 125.796 120.317C126.572 119.544 127.399 118.824 128.272 118.162C128.603 119.362 129.049 120.527 129.603 121.642C131.748 126.003 136.783 132.419 146.904 128.136C150.336 126.694 152.85 124.864 154.684 122.93C160.669 116.619 159.464 109.088 159.464 109.088C159.464 109.088 179.689 108.512 188.421 108.102Z",
    fill: "#55B8CE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M151.863 109.379C146.799 113.535 141.029 113.067 137.681 112.264C137.995 110.642 138.067 108.607 137.791 106.056C137.258 101.152 150.221 98.9747 150.621 103.79C150.827 106.287 151.273 108.094 151.863 109.379Z",
    fill: "url(#paint16_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M153.337 102.339C149.439 105.372 144.102 107.078 141.398 107.805C140.857 107.949 140.289 107.966 139.74 107.853C139.191 107.74 138.677 107.5 138.236 107.154C136.006 105.399 131.88 101.707 131.013 97.8188C130.568 96.252 130.249 94.6523 130.058 93.0348C129.88 91.6132 129.771 90.2122 129.674 88.8936C129.461 86.3408 129.003 83.8143 128.306 81.3488C128.306 81.3488 130.66 78.7487 133.744 75.8458C137.997 71.8426 143.637 67.2708 146.39 68.1567C151.137 69.6896 155.471 77.3827 157.438 79.4039C164.126 86.2709 153.337 102.339 153.337 102.339Z",
    fill: "#FDCEBC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M140.075 96.2777C139.927 96.4652 134.503 103.211 131.013 97.8188C130.568 96.252 130.249 94.6522 130.058 93.0348C129.88 91.6132 129.771 90.2122 129.674 88.8936C129.461 86.3407 129.003 83.8142 128.306 81.3488C128.306 81.3488 130.66 78.7487 133.744 75.8457C134.79 80.1929 136.517 87.7027 136.988 91.7903C137.725 98.2308 139.97 96.3683 140.075 96.2777Z",
    fill: "url(#paint17_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M135.938 87.4741L136.841 94.4008L139.892 94.1618L135.938 87.4741Z",
    fill: "#F2A891"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M143.503 86.25C143.503 86.25 144.419 82.8794 146.951 83.6973C149.484 84.5152 150.317 84.2083 151.477 83.7612L149.494 85.5639C149.494 85.5639 145.373 83.7117 143.503 86.25Z",
    fill: "#242424"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M134.9 89.0607C134.9 89.0607 134.033 86.337 130.681 88.0491C130.681 88.0491 129.744 89.3182 128.795 89.0112L130.696 89.6293C130.696 89.6293 131.938 87.4063 134.9 89.0607Z",
    fill: "#242424"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M143.553 80.1559C143.553 80.1559 147.42 77.3889 150.805 79.3545C150.805 79.3545 148.78 76.4309 144.38 78.6787C144.043 79.1343 143.765 79.6307 143.553 80.1559Z",
    fill: "#242424"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.32 83.2198C130.32 83.2198 132.196 81.2049 134.105 82.8696C134.105 82.8696 136.001 82.9561 134.623 81.8147C133.244 80.6733 130.935 81.3223 130.32 83.2198Z",
    fill: "#242424"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M142.058 100.971C143.035 100.637 144.477 98.4615 145.09 96.564L140.257 98.7046L136.988 98.8117C136.988 98.8117 137.24 102.615 142.058 100.971Z",
    fill: "#E0646C"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M136.928 98.8716C136.515 98.6655 138.391 97.0297 139.993 97.4809C141.877 98.0104 144.079 97.1656 145.09 96.564C145.831 96.1252 143.078 99.3022 139.931 99.4484C138.896 99.5378 137.856 99.3381 136.928 98.8716Z",
    fill: "#6F212B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M140.568 70.2274C140.568 70.2274 158.358 83.8254 159.216 93.278L159.47 83.3721C159.47 83.3721 149.339 68.7584 146.807 67.9405C144.275 67.1225 140.568 70.2274 140.568 70.2274Z",
    fill: "#F2A891"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M134.2 114.872C135.182 115.189 135.358 116.149 134.897 117.272C134.245 118.869 132.311 120.791 129.606 121.642C128.487 121.992 105.666 117.167 115.005 88.9595C118.792 77.5146 118.127 78.3737 122.82 70.6476C126.312 64.8953 139.84 54.7833 148.667 64.3513C148.667 64.3513 150.392 68.748 129.234 79.5502C108.077 90.3523 126.921 112.521 134.2 114.872Z",
    fill: "#3643AB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M143.759 67.8083C143.759 67.8083 142.752 62.5772 145.8 61.3307C150.39 59.4538 161.142 64.141 168.617 87.4965C176.092 110.852 159.33 116.009 155.345 116.351C150.318 116.784 143.71 110.811 149.236 105.087C154.763 99.3638 159.761 93.9164 157.209 85.7391C156.505 83.4975 149.079 74.0634 143.759 67.8083Z",
    fill: "#3643AB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.622 145.952C168.077 148.323 167.722 149.077 167.383 151.78C152.702 146.098 137.459 143.378 121.568 154.871C120.974 152.827 120.742 151.795 120.229 149.858C120.47 149.658 137.88 135.578 168.622 145.952Z",
    fill: "url(#paint18_linear)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M154.687 122.93C152.852 124.864 150.339 126.683 146.906 128.136C136.794 132.419 131.75 126.004 129.606 121.642C132.312 120.791 134.245 118.869 134.897 117.272C135.04 117.494 143.54 130.678 154.687 122.93Z",
    fill: "url(#paint19_linear)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M188.524 108.057C188.524 108.057 183.559 112.534 185.482 117.971C185.482 117.971 202.139 115.573 207.265 122.928C207.265 122.928 205.503 113.809 207.265 113.172C207.265 113.172 206.304 110.616 188.524 108.057Z",
    fill: "url(#paint20_linear)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M106.696 164.76C107.934 171.353 105.571 172.021 105.458 174.489C105.438 174.901 105.429 175.313 105.429 175.725C101.376 175.126 94.9635 173.642 91.2178 169.911C91.2178 169.911 105.045 166.408 106.696 164.76Z",
    fill: "url(#paint21_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M107.412 164.48C107.185 164.593 106.948 164.687 106.705 164.76C106.798 164.668 106.908 164.596 107.03 164.548C107.152 164.5 107.282 164.477 107.412 164.48Z",
    fill: "#F14052"
  }))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M119.888 148.588C118.355 147.589 117.267 146.427 117.436 145.187C118.055 140.654 116.198 143.539 113.721 143.539C111.245 143.539 110.213 142.096 110.213 142.096L110.19 142.148C109.887 139.647 114.126 134.473 114.126 134.473C116.153 132.366 118.125 131.059 119.985 130.312C119.04 133.575 118.771 136.698 118.46 139.212C118.214 141.266 118.873 144.67 119.888 148.588Z",
    fill: "url(#paint22_linear)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M97.595 108.922C95.5188 111.928 88.2172 121.038 77.8097 117.969C65.5097 114.34 53.5832 103.408 53.3975 103.237C55.1666 103.51 56.9546 103.642 58.7447 103.633C61.182 103.606 63.9041 103.252 65.5964 102.032C66.1144 102.792 66.75 103.68 67.4868 104.606C71.2511 109.367 77.7127 115.509 85.2351 114.083C93.3684 112.538 96.4537 110.238 97.595 108.922Z",
    fill: "url(#paint23_linear)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9586 186.29C45.873 185.206 45.1404 185.25 44.7173 185.466C44.5369 185.563 44.3847 185.705 44.2757 185.878L50.0542 194.943C50.0542 194.943 48.4032 202.36 48.4032 204.009C48.4032 205.657 36.9493 193.192 36.9493 193.192L33.4409 181.86L10.5332 168.263C10.5332 168.263 13.2512 162.735 17.7027 160.526C19.6241 159.57 21.8694 159.232 24.3604 160.227L37.5685 173.825L41.4896 174.855C41.4896 174.855 51.2925 182.994 52.3244 186.084C53.3562 189.175 48.816 188.144 46.9586 186.29Z",
    fill: "#C98D73"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.0545 194.943C50.0545 194.943 48.4035 202.36 48.4035 204.009C48.4035 205.657 36.9496 193.192 36.9496 193.192L33.4412 181.86L10.5335 168.262C10.5335 168.262 10.4159 163.672 14.8674 161.463C20.8626 166.964 33.4412 178.358 44.7176 185.47C44.5372 185.567 44.385 185.709 44.276 185.882L50.0545 194.943Z",
    fill: "url(#paint24_linear)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5886 171.559C12.5886 171.559 19.9108 162.261 26.0525 162.275C32.1943 162.29 20.6372 153.222 20.6372 153.222C20.6372 153.222 9.6993 152.192 5.57178 163.318C5.57178 163.318 6.60366 170.735 12.5886 171.559Z",
    fill: "url(#paint25_linear)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7395 203.098C61.5244 202.152 56.8768 200.313 53.6656 197.107C49.6206 193.069 48.3947 179.881 47.8871 166.82C47.7096 162.236 49.3317 158.874 48.5062 156.519C44.8843 146.273 42.5213 137.519 42.3975 137.088C42.9485 136.658 46.1556 134.142 47.4743 132.825C48.9189 131.383 64.6035 155.077 64.6035 175.68C64.5953 193.238 66.2463 201.145 66.7395 203.098Z",
    fill: "url(#paint26_linear)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M335.755 84.7357L337.2 87.1525C337.2 88.9367 335.266 90.383 332.884 90.383C330.503 90.383 328.569 88.9408 328.569 87.1525C328.569 85.3641 330.478 83.9363 332.843 83.9219C329.397 77.9223 323.391 68.9559 323.391 68.9559C333.821 71.111 336.393 63.8052 336.393 63.8052C336.393 67.217 334.535 70.1921 334.535 70.1921C331.659 73.0662 327.725 71.4283 327.725 71.4283L335.755 84.7357Z",
    fill: "#EEC05B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M247.444 37.0368C247.444 38.5944 245.758 39.8553 243.678 39.8553C241.598 39.8553 239.914 38.5944 239.914 37.0368C239.914 35.4792 241.581 34.2306 243.643 34.2162C241.54 30.5551 238.343 25.6268 236.614 22.9979C236.499 23.2572 236.33 23.489 236.119 23.6778C233.607 26.1831 230.177 24.7574 230.177 24.7574L237.175 36.3672L238.442 38.4749C238.442 40.0324 236.756 41.2933 234.676 41.2933C232.596 41.2933 230.912 40.0324 230.912 38.4749C230.912 36.9173 232.577 35.6687 234.639 35.6543C231.634 30.4232 226.384 22.6003 226.384 22.6003C231.199 23.5933 233.871 22.147 235.388 21.158C236.653 20.3339 237.128 19.9486 237.183 19.9033L246.163 34.9291L247.444 37.0368Z",
    fill: "#F14052"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2326 75.1163L33.2266 77.0983C32.7829 78.8269 34.2977 80.7059 36.607 81.2952C38.9164 81.8844 41.1473 80.9593 41.589 79.2349C42.0306 77.5104 40.5364 75.6479 38.2498 75.0483C43.0749 70.0892 51.1173 62.8926 51.1173 62.8926C40.4787 62.4002 39.7976 54.6885 39.7976 54.6885C38.9515 57.985 40.004 61.335 40.004 61.335C42.0781 64.8375 46.2943 64.2194 46.2943 64.2194L35.2326 75.1163Z",
    fill: "url(#paint27_linear)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M258.437 151.135C258.437 151.135 262.719 145.694 262.659 139.123C262.537 125.783 265.724 116.151 270.838 114.256C277.854 111.656 277.813 115.354 279.219 118.45C280.624 121.547 281.055 143.308 275.326 154.905C269.597 166.503 265.193 167.85 265.193 167.85C265.193 167.85 262.68 152.728 258.437 151.135Z",
    fill: "url(#paint28_linear)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M263.336 169.495C261.33 169.853 259.324 169.855 258.626 168.687C258.473 168.069 258.29 167.329 258.077 166.462C258.078 166.454 258.078 166.447 258.077 166.439C257.664 164.537 256.95 161.585 256.292 158.878C255.809 156.778 255.297 154.487 254.779 152.079C255.019 151.49 255.894 150.28 259.022 150.321C259.23 150.324 259.436 150.34 259.642 150.369C261.515 150.628 266.246 155.482 266.658 163.312C266.805 166.32 266.289 168.965 263.336 169.495Z",
    fill: "url(#paint29_linear)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M258.616 168.687C258.502 168.492 258.426 168.279 258.391 168.056C258.333 167.71 258.22 167.158 258.067 166.461C258.279 167.329 258.463 168.077 258.616 168.687Z",
    fill: "url(#paint30_linear)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M314.929 197.632C295.342 212.118 269.764 223.357 253.281 229.154L253.161 229.195C254.216 219.485 256.282 206.944 258.694 203.03C259.152 202.286 259.596 201.538 260.023 200.792C261.453 198.295 262.696 195.812 263.738 193.548C264.629 191.609 265.389 189.827 265.979 188.327C266.285 187.561 266.551 186.867 266.776 186.267C267.395 184.619 267.704 183.636 267.704 183.636L305.471 181.45L312.577 181.038C312.577 181.038 312.529 182.371 312.593 184.417C312.593 184.52 312.593 184.623 312.593 184.738C312.593 184.771 312.593 184.804 312.593 184.837C312.659 186.578 313.64 191.564 314.929 197.632Z",
    fill: "#EC1659"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M312.599 184.843H312.571C308.162 184.843 295.344 183.444 286.93 191.848C280.946 197.834 266.536 202.3 260.019 200.809C263.108 195.34 265.68 189.595 267.702 183.65L305.469 181.462C308.978 182.771 311.681 183.863 312.591 184.429C313.01 184.687 313.047 184.837 312.599 184.843Z",
    fill: "url(#paint31_linear)"
  }), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M318.574 121.654C318.574 127.32 312.222 121.885 310.763 128.247C310.235 130.549 311.574 142.321 311.242 144.936C310.819 148.271 310.971 157.353 311.163 161.432C311.925 177.585 317.198 184.615 311.857 184.866C306.516 185.118 296.758 181.805 292.251 183.115C287.744 184.425 272.623 201.021 261.891 192.162C259.664 190.324 260.574 185.849 262.717 181.036C266.019 173.619 272.041 169.07 270.699 160.639C270.123 157.034 272.81 147.163 270.227 139.643C267.824 132.638 271.415 114.322 272.29 113.646C272.29 113.646 281.784 114.361 282.706 116.246C284.786 120.48 282.087 119.404 291.921 115.247C295.252 113.837 294.546 112.125 296.327 110.246C296.327 110.246 299.033 115.238 299.035 115.238C304.848 109.113 302.933 106.447 302.933 106.447C302.933 106.447 313.349 106.241 317.555 112.247C318.644 113.794 318.574 119.441 318.574 121.654Z",
    fill: "#6337AA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M273.155 83.4253C273.155 83.4253 266.499 85.8585 265.106 93.4589C263.713 101.059 274.721 105.056 281.532 99.8562C288.342 94.656 273.155 83.4253 273.155 83.4253Z",
    fill: "#0C0806"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M303.686 107.255C303.686 107.255 303.4 110.512 301.063 113.959C299.183 116.732 295.98 119.627 290.538 121.053C278.319 124.252 272.311 113.654 272.311 113.654C272.311 113.654 275.64 113.005 278.296 111.314C280.058 110.191 281.526 108.611 281.526 106.455V99.2567C281.526 99.2567 290.839 99.3556 295.047 95.1567L294.983 103.291V104.62C294.98 105.015 295.064 105.406 295.229 105.765C295.394 106.125 295.636 106.443 295.938 106.699C296.24 106.954 296.595 107.14 296.977 107.244C297.359 107.348 297.759 107.366 298.149 107.298L303.686 107.255Z",
    fill: "#E28F71"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M295.043 95.1587L294.979 103.291C289.684 105.019 285.104 104.632 281.523 103.554V99.2566C281.523 99.2566 290.837 99.3576 295.043 95.1587Z",
    fill: "url(#paint32_linear)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M282.624 51.1652C282.624 51.1652 273.51 53.0648 273.71 59.2642C273.943 66.4856 277.518 67.2623 281.123 70.0623C282.527 71.1522 296.647 75.3613 296.647 75.3613C296.647 75.3613 293.242 96.3578 295.043 100.157C296.845 103.956 299.28 107.856 305.49 108.456C311.7 109.055 318.479 107.955 318.779 98.857C319.072 90.0348 312.87 89.9586 312.87 89.9586C312.87 89.9586 316.476 87.7582 314.073 82.9535L311.669 78.1551C311.669 78.1551 316.168 75.6601 313.279 69.7615C311.904 66.9698 308.272 67.1614 308.272 65.3627C308.272 63.5641 303.255 45.965 282.624 51.1652Z",
    fill: "#0C0806"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M278.519 68.2618L274.412 77.5599C274.412 77.5599 271.808 84.7607 273.811 90.1587C275.815 95.5566 279.821 98.5585 281.623 99.3579C283.424 100.157 291.438 101.157 296.445 97.1575C301.451 93.1585 303.166 90.4595 303.166 90.4595C303.166 90.4595 306.772 90.2534 307.773 87.8594C308.427 86.2935 306.47 83.7594 303.567 85.0594L304.068 78.5612C304.068 78.5612 299.66 77.9617 300.263 71.9683C300.263 71.9683 294.253 72.9675 292.649 66.7681C292.641 66.7537 283.926 72.8625 278.519 68.2618Z",
    fill: "#E28F71"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M275.815 85.3597C275.815 85.3597 283.226 85.9592 284.227 84.96C284.227 84.96 282.423 89.5585 279.22 89.5585C276.017 89.5585 275.815 85.3597 275.815 85.3597Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M279.583 76.6777C281.466 74.3417 281.944 71.6061 280.651 70.5675C279.358 69.5289 276.783 70.5807 274.901 72.9167C273.018 75.2528 272.54 77.9884 273.833 79.027C275.126 80.0656 277.7 79.0138 279.583 76.6777Z",
    fill: "#242460"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M292.279 76.4576C294.364 73.8707 294.705 70.6894 293.04 69.3519C291.375 68.0145 288.335 69.0274 286.25 71.6143C284.165 74.2012 283.824 77.3826 285.489 78.72C287.155 80.0574 290.194 79.0446 292.279 76.4576Z",
    fill: "#242460"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M284.607 74.7888L284.729 75.4646C284.729 75.4646 282.498 74.317 280.32 75.0649C280.157 75.1226 280.49 74.5808 280.32 74.6652C280.32 74.6652 280.38 74.5086 280.923 74.2655C281.825 73.8555 283.529 73.6145 284.607 74.7888Z",
    fill: "#242460"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M278.519 82.0593H281.523L281.924 76.4614L278.519 82.0593Z",
    fill: "#ED7D5F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M263.336 150.749C262.923 151.574 269.114 154.573 269.114 154.573C269.114 154.573 264.555 152.447 264.077 153.337C263.598 154.227 264.962 154.703 263.944 155.894C263.286 156.669 263.944 160.427 263.944 160.427L269.31 163.723C269.31 163.723 278.001 162.819 279.423 163.105C292.109 165.674 304.266 170.036 308.41 168.161C308.41 168.161 313.57 160.439 300.473 153.957C300.473 153.957 288.078 159.648 278.391 156.306C278.391 156.306 279.551 154.512 279.01 151.361C278.907 150.756 277.526 150.966 277.359 151.567C276.963 153.01 276.286 154.775 275.295 154.864C273.851 154.996 264.357 147.653 263.325 150.743",
    fill: "#E28F71"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M301.744 152.528C301.744 152.528 306.024 147.089 305.965 140.516C305.843 127.178 304.072 111.293 309.042 109.043C316.702 105.573 321.119 116.749 322.526 119.843C323.934 122.938 324.361 144.703 318.634 156.31C312.907 167.918 310.55 168.532 310.55 168.532C310.55 168.532 305.987 154.12 301.744 152.528Z",
    fill: "url(#paint33_linear)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M297.15 155.486C296.587 155.28 299.79 149.68 304.25 150.296C308.709 150.912 314.187 160.068 314.067 165.613C314.067 165.613 310.199 170.656 305.426 168.866C305.436 168.866 306.165 158.871 297.15 155.486Z",
    fill: "url(#paint34_linear)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M352.696 108.013C352.778 108.013 352.857 107.981 352.915 107.923C352.973 107.865 353.006 107.786 353.006 107.704C353.006 107.622 352.973 107.543 352.915 107.486C352.857 107.428 352.778 107.395 352.696 107.395C352.614 107.395 352.535 107.428 352.477 107.486C352.419 107.543 352.387 107.622 352.387 107.704C352.387 107.786 352.419 107.865 352.477 107.923C352.535 107.981 352.614 108.013 352.696 108.013Z",
    fill: "url(#paint35_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M301.063 113.959C299.183 116.733 295.98 119.627 290.538 121.053C278.319 124.253 272.311 113.654 272.311 113.654C272.311 113.654 275.64 113.005 278.296 111.314C278.292 111.314 291.242 120.322 301.063 113.959Z",
    fill: "url(#paint36_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 48.4053,
    y1: 200.891,
    x2: 109.821,
    y2: 200.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDBD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCB309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9A015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 65.6104,
    y1: 51.9675,
    x2: 104.661,
    y2: 51.8037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9A696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#381616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 3488.07,
    y1: 8468.54,
    x2: 1761.68,
    y2: 6609.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9A696F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#381616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 78.4585,
    y1: 102.344,
    x2: 82.1323,
    y2: 86.5111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C98D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56280F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 187.794,
    y1: 94.823,
    x2: 210.549,
    y2: 94.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 258.184,
    y1: 76.6618,
    x2: 281.707,
    y2: 99.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F28614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEC05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 23084.9,
    y1: 12426.5,
    x2: 26128.9,
    y2: 12426.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 12382.6,
    y1: 6811.19,
    x2: 13204.3,
    y2: 6811.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F28614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEC05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 11893,
    y1: 9080.95,
    x2: 12536.5,
    y2: 9080.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F28614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEC05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 24699.3,
    y1: 19494.7,
    x2: 26341.4,
    y2: 19494.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 193.015,
    y1: 66.8321,
    x2: 214.695,
    y2: 66.8321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 198.855,
    y1: 211.321,
    x2: 212.782,
    y2: 211.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#242859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#5F77D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 47765.1,
    y1: 111383,
    x2: 65787.6,
    y2: 111383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDBD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCB309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9A015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 36775.7,
    y1: 51700.6,
    x2: 61150.1,
    y2: 51700.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDBD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCB309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9A015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 30351.6,
    y1: 19954.3,
    x2: 44749,
    y2: 19954.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDBD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCB309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9A015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 135.234,
    y1: 84.8746,
    x2: 168.097,
    y2: 173.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#242859"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#3643AB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 144.442,
    y1: 103.928,
    x2: 144.92,
    y2: 114.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 8467.65,
    y1: 5250.62,
    x2: 8477.52,
    y2: 6823.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 32342.8,
    y1: 9321.87,
    x2: 35101.8,
    y2: 11258.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A015"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 15880.7,
    y1: 7471.09,
    x2: 18928.7,
    y2: 7471.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F2A891"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDCEBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 20112.9,
    y1: 8444.28,
    x2: 22506.6,
    y2: 8444.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F28614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEC05B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 110.592,
    y1: 168.992,
    x2: 96.9542,
    y2: 172.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6D4052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F14052",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 110.176,
    y1: 139.451,
    x2: 119.993,
    y2: 139.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6D4052",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F14052",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 20501.4,
    y1: 9379.45,
    x2: 16587.9,
    y2: 6722.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C98D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56280F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 8304.08,
    y1: 35959.8,
    x2: 4698.19,
    y2: 38788.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#C98D73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56280F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 5.58003,
    y1: 162.378,
    x2: 27.8604,
    y2: 162.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6D4052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F14052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 9830.34,
    y1: 49993.5,
    x2: 1541.92,
    y2: 52424.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#6D4052"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F14052",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: -1140.75,
    y1: 16401.9,
    x2: 23.7833,
    y2: 16700.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDBD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCB309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9A015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: -250.459,
    y1: 269.606,
    x2: -268.576,
    y2: 274.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#482193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C44B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 15675.1,
    y1: 15334.3,
    x2: 14857.8,
    y2: 15241.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#482193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C44B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 947.351,
    y1: 1977.83,
    x2: 944.778,
    y2: 1977.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#482193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C44B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 222239,
    y1: 18410.8,
    x2: 235800,
    y2: 18410.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FDBD02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FCB309"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F9A015"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#F7931E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 288.307,
    y1: 97.4745,
    x2: 288.186,
    y2: 105.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E28F71",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28F71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 32300.6,
    y1: 39808.4,
    x2: 34025,
    y2: 40024.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#482193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C44B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 24560.8,
    y1: 14103.7,
    x2: 25433.3,
    y2: 14718.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#482193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C44B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 1409.66,
    y1: 430.21,
    x2: 1411.37,
    y2: 430.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#482193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C44B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 38210.4,
    y1: 5957.91,
    x2: 42216.4,
    y2: 5957.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#E28F71",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E28F71",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 240,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommunity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/community.b39de4fc.svg";
export { ForwardRef as ReactComponent };